import React, { useEffect, useState } from "react";
import { db, auth } from "../firebase/firebaseConfig";
import { collection, getDocs, query, where, orderBy } from "firebase/firestore";

const Sesiones = () => {
  const [sesiones, setSesiones] = useState([]);

  useEffect(() => {
    const cargarSesiones = async () => {
      try {
        const user = auth.currentUser;
        if (!user) return;

        // 🔥 traer eventos del usuario
        const q = query(
          collection(db, "eventos_quiz"),
          where("user_id", "==", user.uid),
          orderBy("timestamp", "asc")
        );

        const snapshot = await getDocs(q);

        const eventos = snapshot.docs.map((doc) => doc.data());

        // =========================
        // AGRUPAR POR session_id
        // =========================
        const sesionesMap = {};

        eventos.forEach((e) => {
          if (!e.session_id) return;

          if (!sesionesMap[e.session_id]) {
            sesionesMap[e.session_id] = {
              eventos: [],
            };
          }

          sesionesMap[e.session_id].eventos.push(e);
        });

        // =========================
        // CALCULAR METRICAS
        // =========================
        const sesionesProcesadas = Object.entries(sesionesMap).map(
          ([session_id, data]) => {
            const evs = data.eventos;

            const timestamps = evs
              .map((e) => e.timestamp?.seconds)
              .filter(Boolean);

            const inicio = Math.min(...timestamps);
            const fin = Math.max(...timestamps);

            const duracionSeg = fin - inicio;

            // SOLO contar cuando ve respuesta
            const respuestas = evs.filter(
              (e) => e.evento === "ver_respuesta"
            );

            const total = respuestas.length;

            const correctas = respuestas.filter(
              (e) => e.es_correcta === true
            ).length;

            const porcentaje =
              total > 0 ? Math.round((correctas / total) * 100) : 0;

            const examen = evs.find((e) => e.examen)?.examen || "N/A";

            return {
              session_id,
              inicio,
              duracionSeg,
              total,
              correctas,
              porcentaje,
              examen,
            };
          }
        );

        // ordenar más reciente primero
        sesionesProcesadas.sort((a, b) => b.inicio - a.inicio);

        setSesiones(sesionesProcesadas);
      } catch (error) {
        console.error("Error cargando sesiones:", error);
      }
    };

    cargarSesiones();
  }, []);

  // =========================
  // HELPERS
  // =========================
  const formatFecha = (seconds) => {
    if (!seconds) return "";
    const date = new Date(seconds * 1000);
    return date.toLocaleDateString();
  };

  const formatDuracion = (seg) => {
    if (!seg) return "0 min";
    const min = Math.floor(seg / 60);
    return `${min} min`;
  };

  // =========================
  // UI
  // =========================
  return (

    <div
      style={{
  
        minHeight: "100vh",
  
        padding: "2rem",
  
        background:
          "radial-gradient(circle at top, #162032 0%, #0b1120 45%, #050816 100%)",
  
        color: "white"
      }}
    >
  
      <div
        style={{
  
          maxWidth: "900px",
  
          margin: "0 auto"
        }}
      >
      <h1
        style={{

          fontSize:
            "clamp(2.4rem, 7vw, 4rem)",

          fontWeight: 900,

          marginBottom: "2rem"
        }}
      >
        📊 Historial de Entrenamiento
      </h1>

      {sesiones.length === 0 && <p>No hay sesiones aún</p>}

      {sesiones.map((s) => (
        <div
          key={s.session_id}
          style={{

            background:
              "linear-gradient(145deg, rgba(255,255,255,.08), rgba(255,255,255,.03))",
          
            border:
              "1px solid rgba(255,255,255,.08)",
          
            borderRadius: "24px",
          
            padding: "1.4rem",
          
            marginBottom: "1rem",
          
            backdropFilter: "blur(12px)",
          
            boxShadow:
              "0 12px 30px rgba(0,0,0,.22)"
          }}
        >
          <h3>🧪 Examen: {s.examen}</h3>

          <p>📅 Fecha: {formatFecha(s.inicio)}</p>
          <p>⏱ Duración: {formatDuracion(s.duracionSeg)}</p>

          <p>🔢 Preguntas: {s.total}</p>
          <p>✅ Correctas: {s.correctas}</p>

          <p>

            🎯 Accuracy:
            {" "}

            <strong
              style={{

                color:
                  s.porcentaje >= 70
                    ? "#22c55e"
                    : "#f97316"
              }}
            >
              {s.porcentaje}%
            </strong>

          </p>
        </div>
      ))}
    </div>
    </div>
  );
};

export default Sesiones;